import React from "react";

export default function MySQL_IF() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_IF</h1>
      <p>This is the MySQL_IF component generated from the SQL JSON.</p>
    </div>
  );
}
